module.exports = __webpack_public_path__ + "static/img/309_TO8_2296.44e75a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/309_TO8_2296.jpg
// module id = +Tbi
// module chunks = 0